/**
 * returns address array formated to fit gmap needs
 *
 * @param {Object[]} address
 * @returns {Array[]}
 */
export default (address) => {
  const activeAddress = address.filter(e =>
    e.getIn(['location', 'coordinates'])
  );
  return activeAddress.map((e) => ({
    obj: {
      coordinates: {
        lng: e.getIn(['location', 'coordinates', 0]),
        lat: e.getIn(['location', 'coordinates', 1]),
      },
      title: '',
      value: '',
    },
    color: 'redPin.png',
  }));
};
